import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';

export const ChecklistProgram: React.FC<{
    name: string;
    className?: string;
}> = ({ name, className }) => {
    return (
        <div className='ml-6 mr-8 mb-2'>
            <div className={'flex items-center mx-4' + className}>
                <div className='mr-4'>
                    <FontAwesomeIcon icon={faSquareCheck} style={{color: "#fafafa",}} />
                </div>
                {name}
            </div>
        </div>
    )
}
